import React from 'react';

import { Table as BootstrapTable } from 'react-bootstrap';

import classes from './Table.module.scss';

export const Table: React.FC = ({ children, ...props }) => (
  <BootstrapTable bordered responsive hover className={`${classes.table}`} {...props}>
    {children}
  </BootstrapTable>
);
